import { render, staticRenderFns } from "./FormUno.vue?vue&type=template&id=74e246fd&scoped=true&"
import script from "./FormUno.vue?vue&type=script&lang=js&"
export * from "./FormUno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e246fd",
  null
  
)

export default component.exports